import React from 'react';
import ReactDOM, { hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { isPublicSeoPath, normalizePublicPath } from './seo';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const currentPath = normalizePublicPath(window.location.pathname);
const prerenderRoute = rootEl.dataset.prerenderRoute;
const shouldHydratePublicRoute = prerenderRoute === currentPath && isPublicSeoPath(currentPath);

if (shouldHydratePublicRoute) {
  hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
